module.exports = __webpack_public_path__ + "static/img/kongtiao-lixian.f0496efb.png";